export default __webpack_public_path__ + "static/metrics_02-58bc8b78bc1f8e55c5e1ff15fd23ec84.png";